import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface IPageHeader {
  icon: string;
  showFilterButton?: boolean;
  showFilterCard?: boolean;
  subtitle?: string;
  title: string;
}

const FILTER_CARD_VISIBILITY_STORAGE_KEY = 'showFilterCard';

@Injectable({
  providedIn: 'root',
})
export class PageHeaderService {
  public static headerSetByPage = new BehaviorSubject<Partial<IPageHeader>>({ icon: '', title: '' });
  public static headerSetByPage$ = PageHeaderService.headerSetByPage.asObservable();

  private static readonly filterCardVisibility = new BehaviorSubject<boolean>(
    PageHeaderService.readStoredFilterCardVisibility(),
  );
  public static readonly filterCardVisibility$: Observable<boolean> =
    PageHeaderService.filterCardVisibility.asObservable();

  public static setPageHeader(pageHeader: Partial<IPageHeader>): void {
    PageHeaderService.headerSetByPage.next(pageHeader);
  }

  public static isFilterCardVisible(): boolean {
    return PageHeaderService.filterCardVisibility.value;
  }

  public static setFilterCardVisibility(showFilterCard: boolean): void {
    try {
      localStorage.setItem(FILTER_CARD_VISIBILITY_STORAGE_KEY, String(showFilterCard));
    } catch {
      // Ignore storage failures (e.g. private mode); the toggle still works for this session.
    }

    PageHeaderService.filterCardVisibility.next(showFilterCard);
  }

  private static readStoredFilterCardVisibility(): boolean {
    try {
      return localStorage.getItem(FILTER_CARD_VISIBILITY_STORAGE_KEY) !== 'false';
    } catch {
      return true;
    }
  }
}
